import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'youtube'
})

/**
 * Generated class for the Youtube pipe.
 *
 * See https://angular.io/docs/ts/latest/guide/pipes.html for more info on
 * Angular Pipes.
 */

export class YoutubePipe implements PipeTransform {
  constructor (private dom:DomSanitizer) {

  }
  transform(value: string) {
    return this.dom.bypassSecurityTrustResourceUrl(value);
  }
}



